export const colors = {
  blue: '#3eb0ef',
  green: '#a4d037',
  purple: '#ad26b4',
  yellow: '#fecd35',
  red: '#f05230',
  darkgrey: '#15171A',
  midgrey: '#738a94',
  lightgrey: '#c5d2d9',
  whitegrey: '#e5eff5',
  pink: '#fa3a57',
  brown: '#a3821a',
  // darkmode: color(var(--darkgrey) l(+2%)),
  darkmode: '#191b1f',

  white: `#FFFFFF`,
  royalty: {
    // navy: `#1B3644`,
    // blue: `#00144E`,
    // blue: `#1B3644`,
    // blue: `#25314f`,
    blue: `#0e0f22`,

    // blue: `#001A67`,
    // gold: `#DFC189`,
    // gold: `#ddb97f`,
    white: `#F3E4D2`,
    // blush: `#F4C7D4`,
    // blush: `#f6d9db`,
    blush: `#fff`,

    ivory: `#FFFFF0`,
    // pink: `#ffc2c6`,
    pink: `#fca3cc`,
    // nav color: #9eadba add a pink button

    // blush: `#F8DCE4`,
    // blush: `#FCF1F4`
  },

};

export const textColor = {
  primary: colors.royalty.blush,
  secondary: colors.royalty.blush,
  tertiary: colors.royalty.blush,
};

export const bgColor = {
  primary: colors.royalty.blue,
  secondary: colors.royalty.blue,
  tertiary: colors.royalty.blush,
};

export const logoColors = {
  fill: colors.royalty.blush,
  stroke: colors.royalty.blue,
}